/*
 * Copyright (c) 2024. Amazon.com, Inc. or its affiliates. All rights reserved.
 */

import {
    createLogPrefix,
    Deferred,
    logDebug,
    type LogTarget,
    noop,
    ValidationError,
} from '@amazon/vinyl-util'
import type { AuthTokenProvider } from '@amzn/vinyl-amzn'
import { type Auth, AuthStatus } from '@/auth/auth'
import { data, type ObservableValue } from '@amazon/vinyl-observable'

/**
 *
 */
export class MapAuth implements Auth, LogTarget {
    logPrefix = createLogPrefix('MapAuth')

    private _authToken: string | null = null
    private authTokenSet = new Deferred<void>()
    private _status = data(AuthStatus.PENDING)

    constructor() {
        this.authTokenSet
            .then(() => {
                this._status.value = AuthStatus.SIGNED_IN
            })
            .catch(noop)
        ;(window as any).setAuthToken = (authToken: string) => {
            logDebug(this, 'setAuthToken')
            this._authToken = authToken
            this.authTokenSet.resolve(void 0)
        }
    }

    get status(): ObservableValue<AuthStatus> {
        return this._status
    }

    isSignedIn(): boolean {
        return this._authToken !== null
    }

    get authTokenProvider(): AuthTokenProvider {
        return async (): Promise<string> => {
            await this.authTokenSet
            if (!this._authToken) throw new ValidationError('authToken was set, but undefined')
            return this._authToken
        }
    }

    /**
     * For Map auth, this does nothing.
     */
    signIn() {}

    /**
     * For Map auth, this does nothing.
     */
    signOut() {}
}
